module.exports = __webpack_public_path__ + "img/body-3.653aa33b.png";